import React from 'react'
import './constructioninsurance.scss'
import { Hero, MainHeading, Breadcrumb, PageHeaderIntro, FindAgent, CommonList, FigureCards, NewsCard, Faq, SuccessStories, CommonBlueCards } from '../../../components';
import { images } from "../../../utils/customFn";
import { Container } from 'react-bootstrap';
const ConstructionInsurance = () => {
  const breadcrumbs = [
    { label: "Sentry Insurance home", link: "/" },
    { label: "Who we serve", link: "/who-we-serve/" },
    { label: " Construction insurance", link: "/who-we-serve/construction-insurance" },
  ];

  const HeaderData = [
    {
      para: 'We understand that you can face complex challenges and risks in the construction industry. We’re here to help make it easier for you. From your building and equipment to your day-to-day activities, we have the specific coverages to help your company succeed.',
      para1: 'Whether you’re an independent contractor or you own a large construction company, we’ll work with you to help tailor our coverages to your business.',
    },
  ];

  const Selectoptions = [
    { value: 'Constructions', label: 'Constructions' },
    { value: 'DealerShip', label: 'DealerShip' },
    { value: 'Manufacturing and process industries', label: 'Manufacturing and process industries' },
    { value: 'Retailers and Distributors', label: 'Retailers and Distributors' },
    { value: 'Service industries', label: 'Service industries' },
    { value: 'Trucking', label: 'Trucking' },
  ];

  const Datalist = [
    "Experienced safety services",
    "Knowledgeable claims staff",
    "Flexible payment options",
  ];

  const revenueData = [
    {
      id: 1,
      value: "8",
      unit: "Sentry leaders",
      description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
    },
    {
      id: 2,
      value: "$1B+",
      unit: "Paid in claims",
      description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
    },
    {
      id: 3,
      value: "1992",
      unit: "First year",
      description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
    },
  ];

  const ProductCardData = [
    {
      id: 1,
      title: 'Physical damage insurance',
      description:
        'Weather, animals, other drivers—all things that can damage your vehicle. Let us help cover your costs with physical damage insurance.',
      linkUrl: '',
      linkText: 'More about physical damage insurance >',
    },
    {
      id: 2,
      title: 'Cyber liability insurance',
      description:
        'Data breaches. While we hope they never happen to your business, they are a potential risk. Help protect your company with cyber liability coverage.',
      linkUrl: '/',
      linkText: 'More about cyber liability insurance >',
    },
    {
      id: 3,
      title: 'General liability insurance',
      description:
        'We offer protection against liability claims for your business. Coverage options include product liability, product recall, and errors and omissions.',
      linkUrl: '/',
      linkText: 'More about general liability insurance >',
    },
  ];


  const FaqData = [
    {
      id: 1,
      eventKey: "0",
      header: "What are your giving criteria?",
      body: "We focus our giving efforts on education, workforce development, and local organizations working to improve quality of life and build stronger, more equitable communities where Sentry employees live and work. We don’t give to individuals, political or lobbying organizations, or third-party fundraisers."
    },
    {
      id: 2,
      eventKey: "1",
      header: "Where do you give geographically?",
      body: "We give where our associates live and work. This includes Stevens Point, where Sentry is headquartered, the island of Maui—our home away from home—and the communities where our field offices are located."
    },
    {
      id: 3,
      eventKey: "2",
      header: "Who should I contact for more information?",
      body: "Kalynn Pempek is the Sentry Insurance Foundation Executive Director and can be reached via email at kalynn.pempek@sentry.com or by phone at 715-346-7636."
    }
  ];

  const ResourceData = [
    {
      id: 1,
      title: 'Construction resources',
      description:
        'Explore our resources featuring valuable tools, articles, and guides on topics related to insurance coverages, safety resources, and retirement strategies.',
      linkUrl: '',
      linkText: 'View resources >',
    },
    {
      id: 2,
      title: 'Workers’ compensation 101: A guide for employers',
      description:
        'Accidents happen. That’s why workers’ compensation is crucial—and in some states required—to help you protect your business and your employees. This helpful guide explains the complexities of workers’ compensation.',
      linkUrl: '/',
      linkText: 'View guide >',
    },
  ];

  return (
    <>
      <div className='contruction-main'>
        {/* hero section */}
        <Hero img={images["Construction_Hero.avif"]} />
        <Container>
          {/* Breadcrumb */}
          <Breadcrumb crumbs={breadcrumbs} />

          {/* heading  */}
          <MainHeading title="Construction insurance" showshare={false} />

          {/* page intro */}
          <PageHeaderIntro Data={HeaderData} showImage={false} />

          {/*common list section */}
          <CommonList Heading="What we offer the construction industry:" list={Datalist} />

          {/* figure cards */}
          <FigureCards data={revenueData} heading={'Significant figures'} />

          {/* products cards */}
          <NewsCard Title="Products for contractors" CardData={ProductCardData} showNavLink={false} subTitle="PRODUCTS" />

          {/* Faq's */}
          <Faq FaqData={FaqData} heading={'Construction insurance FAQs'} />

          {/* success stories */}
          <SuccessStories />

          {/* resorce data */}
          <CommonBlueCards CardData={ResourceData} Title="Related resources" />

          {/* find agent */}
          <FindAgent options={Selectoptions} />
        </Container>
      </div>
    </>
  )
}

export default ConstructionInsurance